module.exports = __webpack_public_path__ + "img/0fb5212.jpg";